import template from './location_zone.create.html';
import controller from './location_zone.create.controller';
import './location_zone.create.scss';

const locationZoneCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationZoneCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/create/location_zone.create.component.js